import React from "react";
import { Phone } from "./Hero";
import TTGrid from "./TTGrid";

const TRUST = [
  {
    title: "A grown-up starts every chat",
    body: "Each session opens with your Face ID or passcode. Your child can't wander in on their own.",
    icon: "M7 11V7a5 5 0 0 1 10 0v4M5 11h14v10H5zM12 15v2",
  },
  {
    title: "Notes after every session",
    body: "What they worked on, what clicked, and what's still wobbly, in plain English. No scores to decode.",
    icon: "M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h5",
  },
  {
    title: "You see what I remember",
    body: "I remember things your child tells me so our chats feel personal. You can read every one, and delete any of them.",
    icon: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
  },
  {
    title: "Safeguarding built in",
    body: "If a child says something worrying, I stop the maths, answer with words written for exactly that moment, and point them to a trusted adult and Childline.",
    icon: "M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6zM9 12l2 2 4-4",
  },
  {
    title: "No ads. No strangers. Your data, your call.",
    body: "Nobody else can talk to your child, nothing is sold, and you can delete your account and everything in it from Settings, instantly.",
    icon: "M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3",
  },
];

function Dashboard() {
  return (
    <div className="dash" aria-hidden>
      <div className="dash-top">
        <span className="dash-av">A</span>
        <span>
          <b>Ava</b>
          <span>Year 3 · 12 sessions</span>
        </span>
      </div>
      <div className="dcard">
        <div className="dlabel">
          LAST SESSION <em>Yesterday · 14 min</em>
        </div>
        <p>
          Ava taught Leo why 3 × 4 and 4 × 3 give the same answer — she drew it as an array to
          prove it. Next: the 4 times table.
        </p>
        <span className="dchip">Multiplication</span>
      </div>
      <div className="dcard">
        <div className="dlabel">TIMES TABLES</div>
        <TTGrid />
      </div>
      <div className="dcard">
        <div className="dlabel">SUBJECTS</div>
        <div className="subj">
          Place value <span style={{ background: "#D6EEDF", color: "#1F8A5B" }}>Secure</span>
        </div>
        <div className="subj">
          Fractions <span style={{ background: "#FFF0CC", color: "#9A6A00" }}>Getting there</span>
        </div>
        <div className="subj">
          Telling the time <span style={{ background: "#DDE8F8", color: "#3B7DD8" }}>Just started</span>
        </div>
      </div>
      <div className="dcard">
        <div className="dlabel">WHAT LEO REMEMBERS</div>
        <div className="mem">
          🐉 Loves dragons <u>Remove</u>
        </div>
        <div className="mem">
          ⚽ Plays football on Saturdays <u>Remove</u>
        </div>
      </div>
    </div>
  );
}

export default function Parents() {
  return (
    <section id="parents" className="section parents" data-testid="parents-section">
      <div className="wrap parents-grid">
        <div className="parents-stage rv">
          <Phone>
            <Dashboard />
          </Phone>
        </div>

        <div>
          <span className="eyebrow rv">For parents</span>
          <h2 className="h2 rv" style={{ "--d": "80ms" }}>
            I'm their friend. <br />
            You're <span className="said">in charge.</span>
          </h2>
          <p className="lede rv" style={{ "--d": "160ms" }} >
            Your parent dashboard shows how every chat went and how each topic is coming along.
            Built in England, for UK families, with children's safety as the first job.
          </p>
          <ul className="trust">
            {TRUST.map((t, k) => (
              <li key={t.title} className="rv" style={{ "--d": `${k * 60}ms` }}>
                <span className="trust-ico">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                    <path d={t.icon} />
                  </svg>
                </span>
                <span>
                  <b>{t.title}</b>
                  <p>{t.body}</p>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
